import type { DocumentData, QueryDocumentSnapshot, Timestamp } from "firebase/firestore";
import type { Batch } from "./types";

/**
 * Firestore stores startsOn/endsOn/enrolmentClosesAt/recordingsExpireOn as Timestamp objects,
 * not the plain-number millis the client-side Batch type declares -- same boundary subtlety
 * functions/src/booking.ts's BookingDoc comment calls out for bookings. Batches are read
 * directly by the client (public-read, no callable in between to do this conversion server-
 * side), so it has to happen here.
 */
export function docToBatch(doc: QueryDocumentSnapshot<DocumentData>): Batch {
  const data = doc.data();
  return {
    ...data,
    id: doc.id,
    startsOn: (data.startsOn as Timestamp).toMillis(),
    endsOn: (data.endsOn as Timestamp).toMillis(),
    enrolmentClosesAt: (data.enrolmentClosesAt as Timestamp).toMillis(),
    recordingsExpireOn: data.recordingsExpireOn
      ? (data.recordingsExpireOn as Timestamp).toMillis()
      : null,
  } as Batch;
}
